/* unplugin-vue-components disabled */import "core-js/modules/es.string.match.js";
import "core-js/modules/es.regexp.exec.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.regexp.exec.js";
//
//
//
//
//
//
//
//

import ImgUploadComponent from './ImgUploadComponent.vue';
import ImgUploadInput from './ImgUploadInput.vue';
import store from '@/store';
function isWechat() {
  var ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/micromessenger/i) == 'micromessenger') {
    return true;
  } else {
    return false;
  }
}
export default {
  name: 'ImgUpload',
  components: {
    ImgUploadComponent: ImgUploadComponent,
    ImgUploadInput: ImgUploadInput
  },
  computed: {
    componentId: function componentId() {
      var enterprise = store.state.globalStore.enterprise;
      return enterprise.is_wx_auth && isWechat() ? 'ImgUploadComponent' : 'ImgUploadInput';
    }
  }
};